module.exports = __webpack_public_path__ + "static/img/login_doctor_image.7567117.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_doctor_image.jpg
// module id = 272
// module chunks = 1